import { createSelector } from 'reselect'

/** A Redux selector to retrieve URL Params
 * @param state - The Redux state
 * @param {String} - The URL Params to fetch
 */

const getUrlParams = (type: string, state: any) => state.activity && state.activity[type] ? state.activity[type] : undefined
const getLatestActivities = (state: any) => state.activity && state.activity.latestActivities ? state.activity.latestActivities : undefined

export const selectActivity = createSelector(
  getUrlParams,
  (data) => data ? data.activity : null
)

/** A Redux selector to retrieve inProgress state
 * @param state - The Redux state
 * @param {Boolean} - Fetching Activity in progress
 */

export const selectActivityIsLoading = createSelector(
  getUrlParams,
  (data) => data && data.status ? data.status.isLoading : null
)

/** A Redux selector to retrieve Latest Activities
 * @param state - The Redux state
 * @param {Array} - Fetching Latest Activities
 */

export const selectLatestActivities = createSelector(
  getLatestActivities,
  (data) => data ? data.activities : null
)

/** A Redux selector to retrieve Latest Activities Is Loading state
 * @param state - The Redux state
 * @param {Boolean} - Fetching Latest Activities Is Loading
 */

export const selectLatestActivitiesIsLoading = createSelector(
  getLatestActivities,
  (data) => data && data.status ? data.status.isLoading : null
)

/** A Redux selector to retrieve Total Activities
 * @param state - The Redux state
 * @param {Boolean} - Fetching Toal Activities
 */

export const selectTotalActivities = createSelector(
  getLatestActivities,
  (data) => data ? data.total : 0
)

/** A Redux selector to retrieve Activities dates
 * @param state - The Redux state
 * @param {Object} - Fetching Activities Date
 */

export const selectActivitiesDate = createSelector(
  getLatestActivities,
  (data) => data ? { first: data.firstActivityDate, last: data.lastActivityDate } : {}
)
